<template>
  <div class="home-container" ref="container">
    <div>
      <div class="content" :style="conHeight">
        <div class="contents">
          <el-row style="height:100%" :gutter="8">
            <el-col :span="8">
              <el-col :span="24" class="bg-purple">
                <div class="contentsBox" style="height: 40.5vh; min-height: 315px;">
                  <div class="box-top">
                    <div class="box-top-contents">
                      本月新增服务对象数
                    </div>
                  </div>
                  <div class="total">
                    <div class="total-num">
                      <el-col :span="8">
                        <div class="char">
                          总数:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='total' :duration='2000'></count-to>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="char">
                          男:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='man' :duration='2000'></count-to>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="char">
                          女:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='woman' :duration='2000'></count-to>
                          </div>
                        </div>
                      </el-col>
                    </div>
                    <div class="square" style="margin-top:2vh">
                      <el-carousel height="25vh" style="min-height:250px">
                        <el-carousel-item v-for="(item,i) in newAddData" :key="i">
                          <el-row style="height:100%" :gutter="30">
                            <el-col :span="8" v-for="(item,j) in item" :key="j">
                              <div class="animation">
                                <img :src="a" class="animationImg" style="padding:1%;width:98%">
                                <img :src="b" class="animationImg" style="padding:6%;width:88%">
                                <img :src="c" class="animationImg" style="padding:10%;width:80%">
                                <img :src="d" class="animationImg" style="padding:15%;width:70%">
                                <div class="animationNum">
                                  <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                            :endVal='item.elderlyCount' :duration='2000'></count-to>
                                </div>
                              </div>
                              <div class="square-char">
                                <span>{{item.elderlyClassName}}</span>
                              </div>
                            </el-col>
                          </el-row>
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="contentsBox" style="height: 40.5vh; min-height: 315px;  ">
                  <div class="box-top">
                    <div class="box-top-contents">
                      本月核减服务对象数
                    </div>
                  </div>
                  <div class="total">
                    <div class="total-num">
                      <el-col :span="8">
                        <div class="char">
                          总数:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='totalCut' :duration='2000'></count-to>

                          </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="char">
                          男:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='manCut' :duration='2000'></count-to>

                          </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="char">
                          女:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='womanCut' :duration='2000'></count-to>

                          </div>
                        </div>
                      </el-col>
                    </div>
                  </div>
                  <div id="myCharts"></div>


                </div>
              </el-col>
            </el-col>
            <el-col :span="8">
              <el-col :span="24">
                <div class="contentsBoxCenter" style="height: 83vh; min-height: 648px;  ">
                  <div class="contentsBoxCenter-top">
                    <div class="contentsBoxCenter-top-contents">
                      累计服务金额
                    </div>
                  </div>
                  <div id="lodgingRatio"></div>
                  <div class="contentsBoxCenter-middle">
                    <div class="contentsBoxCenter-middle-contents">
                      累计订单数
                    </div>
                  </div>
                  <div id="order" ></div>
                </div>
              </el-col>
            </el-col>
            <el-col :span="8">
              <el-col :span="24" class="bg-purple">
                <div class="contentsBox" style="height: 40.5vh; min-height: 315px;   ">
                  <div class="box-top">
                    <div class="box-top-contents">
                      现有服务对象数
                    </div>
                  </div>
                  <div class="total">
                    <div class="total-num">
                      <el-col :span="8">
                        <div class="char">
                          总数:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='nowTotal' :duration='2000'></count-to>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="char">
                          男:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='nowMan' :duration='2000'></count-to>

                          </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="char">
                          女:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='nowWoman' :duration='2000'></count-to>

                          </div>
                        </div>
                      </el-col>
                    </div>
                  </div>
                  <div id="myPie"></div>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="contentsBox" style="height: 40.5vh; min-height: 315px;   ">
                  <div class="box-top">
                    <div class="box-top-contents">
                      累计服务对象数
                    </div>
                  </div>

                  <div class="total">
                    <div class="total-num">
                      <el-col :span="8">
                        <div class="char">
                          总数:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='totalAll' :duration='2000'></count-to>

                          </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="char">
                          男:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='manAll' :duration='2000'></count-to>

                          </div>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <div class="char">
                          女:
                          <div class="num">
                            <count-to :startVal='lastPersonNum' style="font-size:22px;color:white" separator=''
                                      :endVal='womanAll' :duration='2000'></count-to>

                          </div>
                        </div>
                      </el-col>
                    </div>
                  </div>


                  <div id="myPictograms">

                  </div>

                </div>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import { getToken,getInsNameByDomainName } from '@/utils/auth';
import a from './img/a.png';
import b from './img/b.png';
import c from './img/c.png';
import d from './img/d.png';
// import {timefilters} from "@/common/times";
export default {
  name: "Home",
  data() {
    return {
      routerValue: [
        [8, '居家养老', '/HomeCare'],
        [8, '机构养老', '/Institution'],
        [8, '社区养老', '/CommunityRetirement'],
        [6, '志愿者', '/Volunteer'],
        [6, '高龄津贴', '/OldAgeAllo'],
        [6, '服务对象', '/ServiceObject'],
        [6, '智能设备', '/IntelligentDevice']
      ],
      nextPersonNum: 20000,
      myCharts: '',
      lodgingRatio: '',
      man: 0,
      woman: 0,
      total: 0,
      manAll: 0,
      womanAll: 0,
      totalAll: 0,
      classOne: 0,
      classTwo: 0,
      classThree: 0,
      lastPersonNum: 0,
      manCut: 0,
      womanCut: 0,
      totalCut: 0,
      nowTotal: 0,
      nowMan: 0,
      nowWoman: 0,
      peiData: [0,0,0],
      lastPersonNumCut: 0,
      cutSubsistence: 0,
      cutEmpty: 0,
      cutOldest: 0,
      conHeight: {
        height: ''
      },
      myPie: '',
      myPictograms: '',
      pictogramsData: [],
      pictogramsDataName: [],
      lodgingRatioData: [],
      order:'',
      orderData:[],
      a:a,
      b:b,
      c:c,
      d:d,
      newAddDataArray:[],
      newAddData:[],
      nowElderly:[],
    }
  },
  mounted() {
    this.$nextTick(() => { // 页面渲染完成后的回调
      this.conHeight.height = this.$refs.container.offsetHeight - 95 + 'px'
    })
    this.init()
    var that = this
    window.addEventListener("resize", () => {
      that.myCharts.resize();
      that.myPie.resize();
      that.myPictograms.resize();
      that.lodgingRatio.resize();
      that.order.resize();
    });
  },
  components: {countTo},
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function () {
      this.conHeight.height = this.$refs.container.offsetHeight - 95 + 'px'
    },
  },
  // created(){
  //    this.init()
  // },
  methods: {
    init() {
      this.$store.commit('update', ['title', getInsNameByDomainName()+'智慧居家养老']);
      this.order = this.$echarts.init(document.getElementById('order'))
      this.lodgingRatio = this.$echarts.init(document.getElementById('lodgingRatio'))
      this.myPictograms = this.$echarts.init(document.getElementById('myPictograms'))
      this.myCharts = this.$echarts.init(document.getElementById('myCharts'))
      this.myPie = this.$echarts.init(document.getElementById('myPie'))
      this.loading(this.myCharts)
      this.loading(this.myPie)
      this.loading(this.myPictograms)
      this.loading(this.lodgingRatio)
      this.loading(this.order)
      this.getAxios("Views/MonthAddNew").then(resolve=>{
          this.man+=resolve.man
          this.woman+=resolve.woman
          this.total+=resolve.total
          this.newAddDataArray=this.newAddDataArray.concat(resolve.jsonObjectList)
          this.newAddData=this.group(this.newAddDataArray, 3);

      })
      this.getAxiosShop("Views/NewInsertElderly").then(resolve=>{
          this.man+=resolve.man
          this.woman+=resolve.woman
          this.total+=resolve.total
          this.newAddDataArray=this.newAddDataArray.concat(resolve.elderClassList)
          this.newAddData=this.group(this.newAddDataArray, 3);
      })
      this.getAxios("Views/MonthCutNew").then(resolve=>{
          this.manCut=resolve.man
          this.womanCut=resolve.woman
          this.totalCut=resolve.total
          var dataName=[]
          var data=[]
          this.myCharts.hideLoading();
          if(resolve.jsonObjectList.length>0){
            resolve.jsonObjectList.forEach(element => {
              if(element.elderlyClassName.length>4){
                element.elderlyClassName.slice(0, 4) + '\n' + element.elderlyClassName.slice(4)
              }
              dataName.push(element.elderlyClassName)
              data.push(element.elderlyCount)
            });
          }
          this.getGauge(dataName,data)
      })
      this.getAxios("Views/ExistingNew").then(resolve=>{
          if(resolve.jsonObjectList.length>0){
            resolve.jsonObjectList.forEach(element => {
              this.nowElderly.push({name:element.elderlyClassName,value:element.elderlyCount})
            });
            this.nowMan+=resolve.man
            this.nowWoman+=resolve.woman
            this.nowTotal+=resolve.total
            this.getPei(this.nowElderly)
          }
          this.myPie.hideLoading();
      })
      this.getAxiosShop("Views/NowElderly").then(resolve=>{
          if(resolve.elderClassList.length>0){
            resolve.elderClassList.forEach(element => {
              this.nowElderly.push({name:element.elderlyClassName,value:element.elderlyCount})
            });
            this.nowMan+=resolve.man
            this.nowWoman+=resolve.woman
            this.nowTotal+=resolve.total
            // this.myPie.hideLoading();
            this.getPei(this.nowElderly)
          }
          this.myPie.hideLoading();
      })
      this.getAxios("Views/TotalObjectNew").then(resolve=>{
        this.manAll+=resolve.man
        this.womanAll+=resolve.woman
        this.totalAll+=resolve.total
        resolve.jsonObjectList.forEach(element => {
          if(element.elderlyClassName.length>4){
            element.elderlyClassName.slice(0, 4) + '\n' + element.elderlyClassName.slice(4)
          }
          this.pictogramsDataName.push(element.elderlyClassName)
          this.pictogramsData.push(element.elderlyCount)
        });
        this.myPictograms.hideLoading();
        this.getPictograms()
      })
      this.getAxiosShop("Views/TotalElderly").then(resolve=>{
        this.manAll+=resolve.man
        this.womanAll+=resolve.woman
        this.totalAll+=resolve.total
        resolve.elderClassList.forEach(element => {
          if(element.elderlyClassName.length>4){
            element.elderlyClassName.slice(0, 4) + '\n' + element.elderlyClassName.slice(4)
          }
          this.pictogramsDataName.push(element.elderlyClassName)
          this.pictogramsData.push(element.elderlyCount)
        });
        this.myPictograms.hideLoading();
        this.getPictograms()
      })
      this.getAxios("Views/TotalOrderNew").then(resolve=>{
        if(this.orderData.length>0){
          this.orderData[0]+=resolve.lastYear
          this.orderData[1]+=resolve.nowYear
          this.orderData[2]+=resolve.lastMonth
          this.orderData[3]+=resolve.nowMonth
        }else{
          this.orderData=[resolve.lastYear,resolve.nowYear,resolve.lastMonth,resolve.nowMonth]
        }
        this.order.hideLoading();
        this.getOrder()
      })
      this.getAxiosShop("Views/OrderCount").then(resolve=>{
        if(this.orderData.length>0){
          this.orderData[0]+=resolve.lastYearOrder
          this.orderData[1]+=resolve.nowYearOrder
          this.orderData[2]+=resolve.lastMonthsOrder
          this.orderData[3]+=resolve.nowMonthsOrder
        }else{
          this.orderData=[resolve.lastYearOrder,resolve.nowYearOrder,resolve.lastMonthsOrder,resolve.nowMonthsOrder]
        }
        this.order.hideLoading();
        this.getOrder()
      })
      this.getAxios("Views/TotalMoneyNew").then(resolve=>{
        if(this.lodgingRatioData.length>0){
          this.lodgingRatioData[0]+=Math.round(resolve.lastYear*100)/100
          this.lodgingRatioData[1]+=Math.round(resolve.nowYear*100)/100
          this.lodgingRatioData[2]+=Math.round(resolve.lastMonth*100)/100
          this.lodgingRatioData[3]+=Math.round(resolve.nowMonth*100)/100
        }else{
          this.lodgingRatioData=[Math.round(resolve.lastYear*100)/100,Math.round(resolve.nowYear*100)/100,Math.round(resolve.lastMonth*100)/100,Math.round(resolve.nowMonth*100)/100]
        }
        this.lodgingRatio.hideLoading();
        this.getLodgingRatio()
      })
      this.getAxiosShop("Views/OrderPrice").then(resolve=>{
        if(this.lodgingRatioData.length>0){
          this.lodgingRatioData[0]+=Math.round(resolve.lastYearMoney*100)/100
          this.lodgingRatioData[1]+=Math.round(resolve.nowYearMoney*100)/100
          this.lodgingRatioData[2]+=Math.round(resolve.lastMonthsMoney*100)/100
          this.lodgingRatioData[3]+=Math.round(resolve.nowMonthsMoney*100)/100
        }else{
          this.lodgingRatioData=[Math.round(resolve.lastYearMoney*100)/100,Math.round(resolve.nowYearMoney*100)/100,Math.round(resolve.lastMonthsMoney*100)/100,Math.round(resolve.nowMonthsMoney*100)/100]
        }
        this.lodgingRatio.hideLoading();
        this.getLodgingRatio()
      })
    },
    loading(myChart){
       myChart.showLoading({
          text: '数据正在努力加载...',
          color: 'rgba(35, 242, 255, 1)',
          textColor: '#FFF',
          maskColor:'transparent',
          fontSize: 14,
      });
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while(index < array.length) {
          newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
    },
    getAxios(url){
        return new Promise((resolve, reject) => {
            this.$axios({
                method: 'post',
                url: this.$visualizationUrl+url,
                data: {
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    visualAccountCode:JSON.parse(getToken()).visualAccount.visualAccountCode
                }
            }).then( (response)=> {
                if(response.data.error == 0){
                    resolve(response.data.data);
                }else if(response.data.error == 1){
                    this.$message({type: 'info', message: response.data.message});
                }
            }).catch(function (error) {
                reject(error.data)
            });
        });
    },
    getAxiosShop(url){
        return new Promise((resolve, reject) => {
            this.$axios({
                method: 'post',
                url: this.$shopUrl+url,
                data: {
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    governmentCodeList:JSON.parse(getToken()).visualAccountShopGovernmentCodeList
                }
            }).then( (response)=> {
                if(response.data.error == 0){
                    resolve(response.data.data);
                }else if(response.data.error == 1){
                    this.$message({type: 'info', message: response.data.message});
                }
            }).catch(function (error) {
                reject(error.data)
            });
        });
    },
    getOrder(){
      var name=['上年度订单数','本年度订单数','上月订单数','本月订单数']
      var color=[['rgba(109, 86, 251, 1)','rgba(42, 152, 255, 1)'],
      ['rgba(255, 218, 0, 1)','rgba(255, 113, 0, 1)'],
      ['rgba(46, 251, 146, 1)','rgba(2, 156, 144, 1)'],
      ['rgba(250, 108, 59, 1)','rgba(255, 120, 145, 1)']]
      let lineY = []
      // var that=this
      for (var i = this.orderData.length-1; i >= 0; i--) {
        var data = {
          name: name[i],
          value: this.orderData[i],
          itemStyle: {
            normal: {
              show: true,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: color[i][0]
              }, {
                offset: 1,
                color: color[i][1]
              }], false),
              barBorderRadius: 10
            },
            emphasis: {
              shadowBlur: 15,
              shadowColor: 'rgba(0, 0, 0, 0.1)'
            }
          }
        }
        lineY.push(data)
      }
      let list=this.orderData
      console.log(list)
      var option ={
        toolbox: {
            show : true,
            feature : {
                mark : {show: true}
            }
        },
        title: {
          show: false
        },
        tooltip: {
          trigger: 'item'
        },
        grid: {
          borderWidth: 0,
          top: '10%',
          left: '5%',
          right: '15%',
          bottom: '3%'
        },
        yAxis: [{
          type: 'category',
          inverse: true,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false,
            inside: false
          },
          data: name
        },
        {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            inside: false,
            textStyle: {
              color: 'rgba(35, 242, 255, 1)',
              fontSize: '14',
            },
            formatter: function (val) {
              return `${val}`
            }
          },
          splitArea: {
            show: false
          },
          splitLine: {
            show: false
          },
          data: list
        }
        ],
        xAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        series: [{
          name: '',
          type: 'bar',
          zlevel: 2,
          barWidth: '20px',
          data: lineY,
          animationDuration: 1500,
          label: {
            normal: {
              color: 'rgba(35, 242, 255, 1)',
              show: true,
              position: [0, '-24px'],
              textStyle: {
                fontSize: 16
              },
              formatter: function (a) {
                return a.name
              }
            }
          }
        }],
        animationEasing: 'cubicOut'
      }
      this.order.setOption(option)
    },
    getLodgingRatio() {
      let data=[];
      let maxData= Math.max(this.lodgingRatioData)
      this.lodgingRatioData.forEach(element => {
        data.push(maxData>=100000?element/10000:element)
      });
      var option = {
        toolbox: {
            show : true,
            feature : {
                mark : {show: true}
            }
        },
        xAxis: {
          type: 'category',
          data: ['去年', '本年', '上月', '本月'],
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: "rgba(35,242,255,1)"
            }
          },
          axisLabel: {
            fontSize: 15
          },
          axisTick: {
            show: false,
            length: 10
          }
        },
        grid: {
          top: "20%",
          left: "15%"
        },
        yAxis: {
          type: 'value',
          name:maxData>=100000?'万元':'元',
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: "rgba(35,242,255,1)"
            }
          },
          axisLabel: {
            fontSize: 15
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: "rgba(0,84,169,1)"
            }
          },

        },

        series: [{
          data: data,
          type: 'bar',
          // showBackground: false,
          barWidth: "30%",
          label: {
            show: true,
            position: 'top',
            fontSize: 18,
            color: "rgba(255,255,255,1)",
          },
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['#28A5FD', '#FE7A41', '#FE41F3', '#FE41F3'];
                return colorList[params.dataIndex]
              },
            }
          }

        }]
      }
      this.lodgingRatio.setOption(option)
    },
    getPictograms() {
      var option = {
        toolbox: {
            show : true,
            feature : {
                mark : {show: true}
            }
        },
        grid: {
          top: '15%',
          bottom: '20%'
        },
        xAxis: {
          data: this.pictogramsDataName,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255, 129, 109, 0.1)',
              width: 1 //这里是为了突出显示加上的
            }
          },
          axisLabel: {
            textStyle: {
              color: 'rgba(35, 242, 255, 1)',
              fontSize: 15
            }
          }
        },
        yAxis: [{
          splitNumber: 2,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: '#999'
            }
          },
          splitArea: {
            areaStyle: {
              color: 'rgba(255,255,255,.5)'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 129, 109, 0.1)',
              width: 0.5,
              type: 'dashed'
            }
          }
        }
        ],
        series: [{
          name: 'hill',
          type: 'pictorialBar',
          barCategoryGap: '0%',
          symbol: 'path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z',
          label: {
            show: true,
            position: 'top',
            distance: 15,
            color: 'rgba(255, 255, 255, 1)',
            fontWeight: 'bolder',
            fontSize: 18,
          },
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = [{
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(255, 0, 73, 1)' //  0%  处的颜色
                  },
                    {
                      offset: 0.5,
                      color: 'rgba(255, 0, 73, 1)' //  50%  处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(41, 193, 95, 0)' //  100%  处的颜色
                    }
                  ],
                  global: false //  缺省为  false
                }, {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(0, 192, 255, 1)' //  0%  处的颜色
                  },
                    {
                      offset: 0.5,
                      color: 'rgba(0, 192, 255, 1)' //  50%  处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(41, 193, 95, 0)' //  100%  处的颜色
                    }
                  ],
                  global: false //  缺省为  false
                }, {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(41, 193, 95, 1)' //  0%  处的颜色
                  },
                    {
                      offset: 0.5,
                      color: 'rgba(41, 193, 95, 1)' //  50%  处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(41, 193, 95, 0)' //  100%  处的颜色
                    }
                  ],
                  global: false //  缺省为  false
                }];
                return colorList[params.dataIndex]
              },
            },
            emphasis: {
              opacity: 1
            }
          },
          data: this.pictogramsData,
          z: 10
        }]
      };
      this.myPictograms.setOption(option);
    },
    getPei(data) {
      var option = {
        color: ['rgba(27, 200, 94, 1)', 'rgba(0, 160, 233, 1)', 'rgba(206, 90, 96, 1)'],
        toolbox: {
            show : true,
            feature : {
                mark : {show: true}
            }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [{
          name: '现有服务对象',
          type: 'pie',
          radius: ['30%', '70%'],
          center: ['50%', '50%'],
          label: {
            show: true,
            fontSize: 16,
            formatter: function (params) {
              if (params.name !== '') {
                return params.name + '\n' + '\n' + params.value;
              } else {
                return '';
              }

            },
          },
          labelLine: {
            length: 10,
            length2: 30,
            show: true,
            color: '#00ffff'
          },
          emphasis: {
            label: {
              show: true
            },
          },
          itemStyle: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 103, 255, 0.2)',
            shadowOffsetX: -5,
            shadowOffsetY: 5,
          },
          data: data
        },
        ]
      };

      this.myPie.setOption(option);
    },
    getGauge(dataName,name) {
      var option = {
        toolbox: {
            show : true,
            feature : {
                mark : {show: true}
            }
        },
        xAxis: {
          type: 'category',
          data:dataName,
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: "rgba(35,242,255,1)"
            }
          },
          axisLabel: {
            fontSize: 15
          },
          axisTick: {
            show: false,
            length: 10
          }
        },
        grid: {
          top: "13%",
          left: "10%"
        },
        yAxis: {
          type: 'value',
          name:'（人）',
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: "rgba(35,242,255,1)"
            }
          },
          axisLabel: {
            fontSize: 15
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              // 使用深浅的间隔色
              color: "rgba(0,84,169,1)"
            }
          },

        },

        series: [{
          data: name,
          type: 'bar',
          // showBackground: false,
          barWidth: "20%",
          label: {
            show: true,
            position: 'top',
            fontSize: 18,
            color: "rgba(255,255,255,1)",
          },
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['#28A5FD', '#FE7A41', '#FE41F3'];
                return colorList[params.dataIndex]
              },
            }
          }

        }]

      };
      this.myCharts.setOption(option);
    },
  }
}


</script>

<style lang="scss" scoped>
.home-container {
  width: 100%;
  height: 100vh;
  margin-top: -75px;
  background-image: url(./img/background.jpg);
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center top;
  min-width: 1320px;
  min-height: 736px;

  .content {
    height: 100%;
    margin: 0;
    padding: 0;
    // margin-top: 80px;
    padding: 0 2.6vw;
    padding-top: 90px;
  }

  .contents {
    min-width: 1220px;
    // height: 100%;

    #myCharts {
      //border: 1px solid yellow;
      height: 27vh;
      width: 100%;
    }

    #myPie {
      //border: 1px solid yellow;
      height: 27vh;
      width: 100%;
    }

    #myPictograms {
      //border: 1px solid yellow;
      height: 25vh;
      width: 100%;
    }
    .bg-purple {
      margin-bottom:2vh;
    }
    .contentsBox {
      border: 1px solid rgba(2, 20, 88, 1);
      background: rgba(1, 25, 81, 0.9);
      border-radius: 10px;
      box-sizing: border-box;
      box-shadow: inset 0px 0px 25px 3px rgb(5, 50, 133);
      position: relative;

      .box-top {
        background-image: url(./img/boxTop.png);
        background-repeat: no-repeat;
        height: 45px;

        .box-top-contents {
          height: 23px;
          font-size: 22px;
          font-family: "Microsoft Himalaya";
          color: rgba(35, 242, 255, 1);
          margin-left: 40px;
          padding-top: 6px;
        }
      }

      .total {
        width: 90%;
        height: 40px;
        background: rgba(3, 46, 127, 1);
        border: 1px solid rgba(1, 76, 191, 1);
        border-radius: 5px;
        margin: 15px auto;

        .total-num {
          height: 40px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(35, 242, 255, 1);
          line-height: 40px;

          .char {
            text-align: center;

            .num {
              font-size: 22px;
              font-family: Arial;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              display: inline-block;
            }
          }

        }

        .square {
          text-align: center;
          margin-top: 30px;

          .animation {
            width: 100%;
            height: auto;
            padding-top: 100%;
            position: relative;
            .animationImg{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              animation: turn 3.5s linear infinite;
            }
            .animationNum{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            @keyframes back {
              0% {
                -webkit-transform: rotate(0deg);
              }
              25% {
                -webkit-transform: rotate(-90deg);
              }
              50% {
                -webkit-transform: rotate(-180deg);
              }
              75% {
                -webkit-transform: rotate(-270deg);
              }
              100% {
                -webkit-transform: rotate(-360deg);
              }
            }
            @keyframes turn {
              0% {
                -webkit-transform: rotate(0deg);
              }
              25% {
                -webkit-transform: rotate(90deg);
              }
              50% {
                -webkit-transform: rotate(180deg);
              }
              75% {
                -webkit-transform: rotate(270deg);
              }
              100% {
                -webkit-transform: rotate(360deg);
              }
            }

          }

          .square-char {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(35, 242, 255, 1);
            margin-top: 5px;
          }
        }

      }
    }

    .contentsBoxCenter {
      //border: 1px solid red;
      position: relative;
      background-size: 100% 100%;
      background-image: url(./img/middel-background.png);
      background-repeat: no-repeat;


      #order{
        width: 100%;
        height: 33vh;
        margin-top: 1vh;
      }


      .contentsBoxCenter-top {
        height: 45px;
        width: 100%;
        background-size: 100% 100%;
        background-image: url(./img/center-top.png);
        background-repeat: no-repeat;


        .contentsBoxCenter-top-contents {
          height: 23px;
          font-size: 22px;
          font-family: "Microsoft Himalaya";
          color: rgba(35, 242, 255, 1);
          margin-left: 48px;
          padding-top: 6px;
        }


      }

      #lodgingRatio {
        width: 100%;
        height: 37vh;
      }



      .contentsBoxCenter-middle{
        height: 45px;
        width: 100%;
        background-size: 100% 100%;
        background-image: url(./img/center-top.png);
        background-repeat: no-repeat;
        .contentsBoxCenter-middle-contents{
          height: 23px;
          font-size: 22px;
          font-family: "Microsoft Himalaya";
          color: rgba(35, 242, 255, 1);
          margin-left: 48px;
          padding-top: 6px;
        }
      }

    }


  }


}

</style>
